import React from 'react';
import PropTypes from 'prop-types';
import Column from 'components/shared/Column';
import Row from 'components/shared/Row';
import Text from 'components/shared/Text';
import { useIsMobile } from 'helpers/hooks';

import styles from './styles.module.scss';

function Value({ children, name }) {
  const isMobile = useIsMobile();

  if (!children) return null;

  return (
    <Row styles={[styles.valueRow]}>
      <Column lg={4} sm={4}>
        <Text tall muted>
          {name}
        </Text>
      </Column>

      <Column lg={8} sm={8} endAligned={isMobile}>
        <Text tall monospaced styles={[styles.valueText]}>
          {children}
        </Text>
      </Column>
    </Row>
  );
}

Value.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.any
};

Value.defaultProps = {
  children: null
};

export default Value;
